<template>
  <div class="_main">
    <div class="_Left">
      <div style="margin-bottom: 10px">企业组织结构</div>
      <el-input placeholder="请输入部门关键字" v-model="filterText"> </el-input>

      <el-tree
        class="filter-tree"
        :data="organizatonData"
        @node-click="organizationClick"
        :props="defaultProps"
        default-expand-all
        :filter-node-method="filterNode"
        ref="customTree"
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ node }">
          <span class="_imgDiv">
            <img
              v-if="node.level == 0"
              src="@/assets/pImg/szqy.png"
              alt=""
              class="_img"
            />
            <img v-else src="@/assets/pImg/dept.svg" alt="" class="_img" />
            {{ node.label }}
          </span>
        </span>
      </el-tree>
    </div>
    <div class="_Right">
      <div class="_righTop">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          inline
          label-width="100px"
        >
          <el-form-item label="人员姓名：">
            <el-input
              v-model="searchModel.name"
              placeholder="请输入人员姓名"
              style="width: 130px"
            ></el-input>
          </el-form-item>
          <el-form-item label="人员工号：">
            <el-input
              v-model="searchModel.number"
              placeholder="请输入人员工号"
              style="width: 130px"
            ></el-input>
          </el-form-item>
          <el-form-item label="岗位种类：">
            <el-select
              v-model="searchModel.jobType"
              placeholder="请选择岗位种类"
              style="width: 150px"
            >
              <el-option
                v-for="item in jobTypeData"
                :key="item.dictValue"
                :label="item.dictName"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="searchBtn()"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="_rightBottom">
        <div class="_topFunc">
          <div>
            <el-button type="primary" size="small" @click="addStaff()"
              >新增</el-button
            >
            <el-button size="small" @click="exportFile()">导入</el-button>
          </div>
          <div>
            <el-button
              size="small"
              type="primary"
              @click="showDeleteAll()"
              v-if="multipleSelection.length > 0"
              >删除</el-button
            >
          </div>
        </div>

        <div class="_employeeTable">
          <el-table
            :data="groupData"
            v-loading="pageLoading"
            border
            height="100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column prop="headImage" label="照片" width="80">
              <template slot-scope="scope">
                <img
                  :src="scope.row.headImage"
                  alt=""
                  class="_staffImg"
                  v-if="scope.row.headImage != ''"
                  width="40"
                />
                <span v-else class="_empty">空</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="120">
            </el-table-column>
            <el-table-column prop="phone" label="电话" width="120">
            </el-table-column>
            <el-table-column prop="sex" label="性别" width="100">
            </el-table-column>
            <el-table-column prop="employTypeName" label="状态" width="120">
              <template slot-scope="scope">
                <el-button
                  :class="{ 'custom-button': true }"
                  @click="statusEditPop(scope.row)"
                >
                  <span>{{ scope.row.jobStatus == 0 ? '在职' : '离职' }}</span>
                  <img
                    src="@/assets/pImg/statusEdit.svg"
                    alt="按钮图片"
                    class="button-image"
                  />
                </el-button>
              </template>
            </el-table-column>
            <!--            <el-table-column prop="groupName" label="所在班组">-->
            <!--            </el-table-column>-->
            <el-table-column prop="deptName" label="部门" width="180">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="infoEdit(scope.row)"
                  >资料编辑</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  @click="showDelete(scope.row)"
                >
                  <span style="color: red">删除</span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="_pageSelect">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[10, 50, 100]"
            :page-size="this.searchModel.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>

        <el-dialog
          title="删除"
          :visible.sync="dialogVisible"
          width="30%"
          align-center
          class="centered-dialog"
        >
          <span class="_info">{{ delInfo }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="ensureDelete()">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="导入人员资料"
          :visible.sync="dialogExport"
          width="35%"
          align-center
          class="centered-dialog"
        >
          <div>
            <div class="_exportTop">
              <div class="_divLeft">
                <div class="_divTitle">1.下载人员资料的模板，填写内容</div>
                <div class="_divImg">
                  <img src="@/assets/pImg/xlsx2.svg" alt="" />
                </div>
                <div class="_divTitle">
                  <!-- <el-button type="text" size="medium" @click="dowmLoadFiles()">下载</el-button> -->
                  <a
                    style="height: 30px; text-align: center"
                    :href="downloadUrl"
                    target="_blank"
                    >下载模版</a
                  >
                </div>
              </div>
              <div class="_divRight">
                <div class="_divTitle">2.上传填好的文件</div>
                <div class="_divImg">
                  <img v-if="showxlsx" src="@/assets/pImg/xlsx1.svg" />
                  <span
                    style="width: 100%; height: 50px; text-align: center"
                    v-else
                  >
                    {{ filename }}
                  </span>
                </div>
                <div class="_divTitle">
                  <input
                    type="file"
                    ref="fileInput"
                    @change="onFileChange"
                    style="display: none"
                    accept=".xlsx"
                  />
                  <el-button size="medium" type="text" @click="uploadFlie()"
                    >上传文件</el-button
                  >
                </div>
              </div>
            </div>
            <div>
              <div>注意事项:</div>
              <div>1、模板中的说明文字不要删除。</div>
              <div>2、文本框内容的开头和结尾不要包含空格。</div>
              <div>3、上传文件后，点击弹窗确定，才会正式开始导入。</div>
              <div>4、如果导入失败，请按照提示进行修改后再次导入。</div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogExport = false">取 消</el-button>
            <el-button type="primary" @click="submitUpload">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          :title="statusTitle"
          :visible.sync="dialogStatus"
          width="30%"
          align-center
          class="centered-dialog"
        >
          <div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
            >
              <el-form-item label="岗位状态：">
                <el-select
                  v-model="ruleForm.jobStatus"
                  placeholder="请选择岗位状态"
                >
                  <el-option label="在职" value="0"></el-option>
                  <el-option label="离职" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span style="padding-left: 100px"
              >选择离职后，此人员的账号将<span style="color: red">停用</span
              >，请谨慎操作。</span
            >
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogStatus = false">取 消</el-button>
            <el-button type="primary" @click="eidtStaffStatus()"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOrganizationList,
  getGroupList,
  getDictList,
  deleteStaff,
  updateStaffJobStatus,
  exportEmployeeDataByFile,
} from '@/api/pServer/staff';
export default {
  watch: {
    filterText(val) {
      this.$refs.customTree.filter(val);
    },
  },
  data() {
    return {
      // [Vue warn]: Property or method "rules" is not defined on the instance but referenced during render. Make sure that this property is reactive, either in the data option, or for class-based components, by initializing the property. See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.
      pageLoading: false,
      rules: {},
      totalCount: 0,
      searchModel: {
        name: '',
        number: '',
        jobType: '',
        current: 1,
        deptId: '',
        deptIdList: [],
        level: '',
        phone: '',
        size: 10,
      },
      deleteList: [],
      ruleForm: {
        jobStatus: '',
      },
      filterText: '',
      organizatonData: [],
      groupData: [],
      jobTypeData: [],
      dialogVisible: false,
      dialogExport: false,
      dialogStatus: false,
      statusTitle: '',
      delInfo: '',
      multipleSelection: [],
      eidtStatusId: '',
      defaultProps: {
        children: 'childDeptDto',
        label: 'name',
      },
      //岗位种类
      jobType: { dictCode: 'job_type' },
      showxlsx: true,
      filename: '',
      uploadFile: null,
      downloadUrl: `${process.env.VUE_APP_BASE_URL}${'/common/template/1'}`,
    };
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    organizationClick(data, node) {
      // data.id,data.level
      this.searchModel.name = '';
      this.searchModel.num = '';
      this.searchModel.jobType = '';
      this.searchModel.deptId = data.id;
      this.searchModel.level = data.level;
      this.getGroupList(this.searchModel);
    },
    //查询
    searchBtn() {
      this.searchModel.deptId = '';
      this.searchModel.level = '';
      this.getGroupList(this.searchModel);
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.searchModel.size = val;
      this.searchModel.current = 1;
      this.getGroupList(this.searchModel);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.searchModel.current = val;
      this.getGroupList(this.searchModel);
    },

    statusEditPop(data) {
      this.ruleForm.jobStatus = '';
      this.dialogStatus = true;
      this.statusTitle = `修改状态-${data.name}`;
      this.eidtStatusId = data.id;
    },
    //修改状态
    eidtStaffStatus() {
      this.dialogStatus = false;
      if (this.ruleForm.jobStatus.length != 0) {
        this.updateStaffJobStatus({
          id: this.eidtStatusId,
          jobStatus: this.ruleForm.jobStatus,
        });
      }
    },
    //资料编辑
    infoEdit(data) {
      this.$router.push('/staffEdit?staffId=' + data.id);
    },
    showDelete(data) {
      this.multipleSelection = [];
      this.delInfo = `确定删除 ${data.name}`;
      this.dialogVisible = true;
      this.deleteList = [data.id];
    },
    showDeleteAll() {
      this.deleteList = [];
      this.delInfo = `确定删除 ${this.multipleSelection.length}位人员？ `;
      this.dialogVisible = true;
      this.multipleSelection.forEach((data) => {
        this.deleteList.push(data.id);
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    ensureDelete() {
      this.dialogVisible = false;
      this.deleteStaff({ idList: this.deleteList });
    },
    //下载文件
    dowmLoadFiles() {
      CommonFile.downloadTemplate({ fileType: '1' }).then((res) => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = '员工信息导入模版.xlsx';
        link.click();
        URL.revokeObjectURL(downloadUrl);
      });
      window.open(this.downloadUrl, '_blank');
    },
    async onFileChange(event) {
      this.showxlsx = false;
      const selectedFiles = Array.from(event.target.files);
      this.uploadFile = selectedFiles[0];
      this.filename = this.uploadFile.name;
      // console.log("文件名:", this.filename);
    },
    uploadFlie() {
      this.$refs.fileInput.click();
    },
    //上传文件
    submitUpload() {
      if (this.filename.length == 0) {
        this.$message.error('请上传文件！');
        return;
      }
      this.pageLoading = true;
      exportEmployeeDataByFile('zngy', this.uploadFile).then((res) => {
        this.pageLoading = false;
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.filename = '';
          this.dialogExport = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 新增人员
    addStaff() {
      this.$router.push('/staffAdd');
    },
    exportFile() {
      this.dialogExport = true;
    },
    // 获取组织结构
    async getOrganizationList() {
      const res = await getOrganizationList();
      //重新加载了，用push没关系
      this.organizatonData.push(res.data.data);
      // 默认取最上层的id值作为传参
      this.searchModel.deptId = res.data.data.id;
      console.log(this.searchModel.deptId);
      
    },
    // 获取分组人员信息
    async getGroupList(params) {
      console.log(params,"getGroupList params");
      this.pageLoading = true;
      
      const res = await getGroupList(params);
      this.totalCount = res.data.data.total;
      this.groupData = res.data.data.records;
      this.pageLoading = false;
    },
    //获取岗位种类
    async getJobType(params) {
      const res = await getDictList(params);
      this.jobTypeData = res.data.data;
    },
    //删除人员
    async deleteStaff(params) {
      await deleteStaff(params);
      this.getGroupList(this.searchModel);
    },
    //更换员工状态
    async updateStaffJobStatus(params) {
      await updateStaffJobStatus(params);
      this.getGroupList(this.searchModel);
    },
  },
  async created() {
    await this.getOrganizationList();
    this.getJobType(this.jobType);
    this.getGroupList(this.searchModel);
  },
};
</script>
<style scoped>
/* :deep(.el-tree-node__content) {
    height: 40px !important;
} */
.custom-button {
  text-align: left;
  /* 设置文字左对齐 */
  justify-content: center;
  /* 设置内容纵向居中 */
  border: none;
  /* 隐藏边框 */
  padding-right: 0px;
  /* 移除默认的右内边距，为图片留出空间 */
}

/* 取消点击高亮 */
.custom-button:focus,
.no-highlight:hover {
  background-color: initial;
  border-color: initial;
  box-shadow: none;
}

.custom-button .el-button__text {
  display: inline-block;
  /* 让文字行内显示 */
  vertical-align: middle;
  /* 设置文字垂直居中 */
}

.custom-button .button-image {
  vertical-align: middle;
  /* 设置图片垂直居中 */
  margin-left: 0px;
  /* 设置图片与文字之间的距离 */
}

._main {
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
}

._Left {
  width: 240px;
  height: 100%;
  background-color: #fff;
  border-radius: 4px;
  padding: 20px 5px 10px 20px;
  margin-right: 15px;
  overflow-y: auto;
}

._Right {
  flex: 1;
}

._righTop {
  height: 60px;
  background-color: #fff;
  border-radius: 4px;
  padding-left: 20px;
  padding-top: 10px;
  margin-bottom: 20px;
}

._rightBottom {
  height: calc(100% - 80px);
  background-color: #fff;
  border-radius: 4px;
}

._topFunc {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}

._employeeTable {
  padding: 0 20px;
  height: calc(100% - 120px);
  overflow-y: auto;
}

._pageSelect {
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
}

._imgDiv {
  height: 60px;
  display: flex;
  align-items: center;
}

._img {
  height: 15px;
  width: 15px;
  padding: 10px;
}

._info {
  font-weight: 700;
  font-size: 16px;
}

._exportTop {
  padding-bottom: 20px;
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
}

._divLeft {
  border-right: 1px solid black;
  height: 160px;
  width: 50%;
}

._divRight {
  height: 160px;
  width: 50%;
}

._divLeft > div,
._divRight > div {
  /* flex: 1; */
  display: flex;
  justify-content: center;
}

._divTitle {
  height: 30px;
}

._divImg {
  margin-top: 25px;
  margin-bottom: 25px;
}

._staffImg {
  padding-top: 10px;
  height: 100%;
  width: 100%;
}

._empty {
  padding: 5px;
  height: 30px;
  width: 100%;
  border: 1px dashed black;
  border-radius: 100%;
}
</style>

<style>
.el-tree-node__content {
  height: 40px !important;
}

.centered-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-select {
  width: 100%;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  text-align: center;
}

.el-table .cell {
  display: block !important;
}

/* 节点图标隐藏 */
.filter-tree .el-tree-node__expand-icon {
  display: none;
}
</style>
